module.exports = __webpack_public_path__ + "static/media/Card_P.89cb3fdc.svg";